import { LoaderFunction } from 'react-router-dom'
import {
    PrincipalReferenceRequest,
    PrincipalReferenceSurveyErrorReason,
} from './schema'
import { getSurvey, recordVisit } from './api'
import { logger } from '../../helpers/logger'
import { getError } from '../../helpers/utils'
import { captureException } from '@sentry/react'
import { isSurveyNetworkError } from './helper'

export const PrincipalReferenceSurveyLoader: LoaderFunction = async ({
    params,
}): Promise<{
    data: PrincipalReferenceRequest | null
    errorReason?: PrincipalReferenceSurveyErrorReason
}> => {
    try {
        if (!params.requestId) throw new Error('Missing referee UUID')
        const snap = await getSurvey(params.requestId)
        if (!snap.exists()) {
            return { data: null }
        }
        try {
            await recordVisit(params.requestId)
        } catch (e) {
            logger.warn(`Failed to update visited timestamp: ${getError(e)}`)
            captureException(e, {
                tags: {
                    feature: 'Referee Survey',
                    eventType: 'referee_visited_timestamp_update_error',
                    route: '/referee/:refereeId',
                    refereeId: params.refereeId,
                },
            })
        }

        return {
            data: snap.val(),
        }
    } catch (e) {
        logger.debug(getError(e))
        captureException(e, {
            tags: {
                feature: 'Referee Survey',
                eventType: 'referee_survey_loader_error',
                errorReason: isSurveyNetworkError(e)
                    ? 'network-error'
                    : 'survey-unavailable',
                route: '/referee/:refereeId',
                refereeId: params.refereeId ?? 'missing',
            },
        })
        return {
            data: null,
            errorReason: isSurveyNetworkError(e)
                ? 'network-error'
                : 'survey-unavailable',
        }
    }
}
